// src/components/onboarding/OnboardingTopBar.jsx
import React from "react";
import { ChevronLeft } from "lucide-react";
import ProgressLine from "@/sot/primitives/ProgressLine.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

export default function OnboardingTopBar({ step, total, onBack }) {
  const { t } = useLanguage();
  const safeTop =
    "calc(var(--afrimed-head-air, 28px) + env(safe-area-inset-top))";

  return (
    // ✅ No background paint here — let the page/shell own it
    <div className="w-full">
      <div className="afrimed-rail afrimed-rail--comfortable">
        {/* breathing above the back button */}
        <div style={{ height: safeTop }} />

        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={onBack}
            aria-label={t("common.back", "Back")}
            className={[
              "inline-flex items-center justify-center",
              "topbar-back",
              "h-10 w-10 rounded-[12px]",
              "text-[rgb(var(--afrimed-foreground))]",
            ].join(" ")}
          >
            <ChevronLeft className="w-6 h-6 text-[rgb(var(--clr-on-surface))]" />
          </button>

          <div className="text-sm select-none text-[rgb(var(--clr-on-surface-variant))]">
            {step}/{total}
          </div>
        </div>

        <div className="mt-4">
          <ProgressLine value={total ? step / total : 0} />
        </div>
      </div>
    </div>
  );
}
